import { AutoComplete, Input, Tooltip } from "antd";
import { t } from "i18next";
import { SearchIcon, EditIcon, DetailIcon, MailIcon, AscRed, DescGrey, DeleteIcon } from "../../../asset";
import style from './userPage.module.css'
import CustomTable from "../../../component/table/CustomTable";
import PrimaryButton from "../../../component/button/PrimaryButton";
import { useUser } from "./UserPage.hooks";
import Breadcumbs from '../../../component/page-components/breadcumbs/breadcumbs';
import DeleteConfirmationModal from "../../../component/modal/DeleteConfirmationModal";
import SuccessModal from "../../../component/modal/SuccessModal";
import ModalFailedDelete from "../../../component/modal/ModalFailedDelete";

export default function UserList() {

    const {
        list,
        options,
        doGetListUser,
        onSearch,
        onSelect,
        toInviteList,
        toUserDetail,
        totalData,
        handleChangeLimit,
        doSort,
        sorting,
        searchKeyword,
        statePageSize,
        toEdit,
        deleteConfirmationModalOpen,
        successModalOpen,
        selectedUpdatedAt,
        selectedUserId,
        selectedUserName,
        doDeleteUser,
        setSelectedUpdatedAt,
        setSelectedUserName,
        setSelectedUserId,
        setDeleteConfirmationModalOpen,
        cannotDeleteError,
        setCannotDeleteError,
        currentPage,
        onClear
    } = useUser()


    const UserListColumn = [
        {
            title: (
                <div className="flex w-auto">
                    <span className="font-roboto text-lg text-[#222222]">
                        {t("USER:USER_ID_FIELD")}
                    </span>
                    <div style={{ marginLeft: "10px", marginTop: "3px" }}>
                        <div className={style.SortArea}>
                            <Tooltip title={t("Asc")} color="#CF0000">
                                <img
                                    src={sorting === "id asc" ? AscRed : DescGrey}
                                    alt="asc"
                                    className={sorting === "id asc" ? "w-[10px] h-[10px] cursor-pointer" : "rotate-180 w-[10px] h-[10px] cursor-pointer"}
                                    onClick={() => doSort("id asc")}
                                />
                            </Tooltip>

                            <Tooltip title={t("Desc")} color="#CF0000">
                                <img
                                    src={sorting === "id desc" ? AscRed : DescGrey}
                                    alt="desc"
                                    className={sorting === "id desc" ? "w-[10px] h-[10px] cursor-pointer rotate-180" : "w-[10px] h-[10px] cursor-pointer"}
                                    onClick={() => doSort("id desc")}
                                />
                            </Tooltip>
                        </div>
                    </div>
                </div>
            ),
            dataIndex: 'userId',
            key: 'userId',
            render: (userId) => <span>{userId}</span>,
        },
        {
            title: (
                <div className="flex w-auto">
                    <span className="font-roboto text-lg text-[#222222]">
                        {t("USER:USERNAME_FIELD")}
                    </span>
                    <div style={{ marginLeft: "10px", marginTop: "3px" }}>
                        <div className={style.SortArea}>
                            <Tooltip title={t("Asc")} color="#CF0000">
                                <img
                                    src={sorting === "username asc" ? AscRed : DescGrey}
                                    alt="asc"
                                    className={sorting === "username asc" ? "w-[10px] h-[10px] cursor-pointer" : "rotate-180 w-[10px] h-[10px] cursor-pointer"}
                                    onClick={() => doSort("username asc")}
                                />
                            </Tooltip>

                            <Tooltip title={t("Desc")} color="#CF0000">
                                <img
                                    src={sorting === "username desc" ? AscRed : DescGrey}
                                    alt="desc"
                                    className={sorting === "username desc" ? "w-[10px] h-[10px] cursor-pointer rotate-180" : "w-[10px] h-[10px] cursor-pointer"}
                                    onClick={() => doSort("username desc")}
                                />
                            </Tooltip>
                        </div>
                    </div>
                </div>
            ),
            dataIndex: 'username',
            key: 'username',
            render: (username) => <span>{username}</span>,
        },
        {
            title: (
                <span className="font-roboto text-lg text-[#222222]">
                    {t("USER:EMAIL_FIELD")}
                </span>
            ),
            dataIndex: 'email',
            key: 'email',
            render: (email) => <span>{email}</span>,
        },
        {
            title: (
                <span className="font-roboto text-lg text-[#222222]">
                    {t("USER:FIRST_NAME_FIELD")}
                </span>
            ),
            dataIndex: 'firstName',
            key: 'firstName',
            render: (firstName) => <span>{firstName}</span>,
        },
        {
            title: (
                <span className="font-roboto text-lg text-[#222222]">
                    {t("USER:LAST_NAME_FIELD")}
                </span>
            ),
            dataIndex: 'lastName',
            key: 'lastName',
            render: (lastName) => <span>{lastName}</span>,
        },
        {
            title: (
                <span className="font-roboto text-lg text-[#222222]">
                    {t("USER:MOBILE_PHONE_FIELD")}
                </span>
            ),
            dataIndex: 'mobilePhone',
            key: 'mobilePhone',
            render: (mobilePhone) => <span>{mobilePhone}</span>,
        },
        {
            title: (
                <span className="font-roboto text-lg text-[#222222]">
                    {t("USER:ACTION_FIELD")}
                </span>
            ),
            dataIndex: 'action',
            key: 'action',
            render: (action) => (action),
        },
    ]

    const dataSource = list?.map((item) => (
        {
            userId: (
                <span className="font-roboto text-lg text-[#222222]">
                    {item.id}
                </span>
            ),
            username: (
                <span className="font-roboto text-lg text-[#222222]">
                    {item.username}
                </span>
            ),
            email: (
                <span className="font-roboto text-lg text-[#222222]">
                    {item.email}
                </span>
            ),
            firstName: (
                <span className="font-roboto text-lg text-[#222222]">
                    {item.first_name}
                </span>
            ),
            lastName: (
                <span className="font-roboto text-lg text-[#222222]">
                    {item.last_name}
                </span>
            ),
            mobilePhone: (
                <span className="font-roboto text-lg text-[#222222]">
                    {item.phone}
                </span>
            ),
            action: (
                <div className="flex gap-[26px]">
                    <Tooltip title={t("USER:EDIT_TOOLTIP")} color="#CF0000">
                        <button>
                            <img src={EditIcon} alt="icon-edit" onClick={() => toEdit(item.id)} />
                        </button>
                    </Tooltip>
                    <Tooltip title={t("USER:DELETE_TOOLTIP")} color="#CF0000">
                        <button>
                            <img src={DeleteIcon} alt="icon-delete" onClick={() => deleteData(item.id, item.updated_at, item.username)} />
                        </button>
                    </Tooltip>
                    <Tooltip title={t("USER:DETAIL_TOOLTIP")} color="#CF0000">
                        <button>
                            <img src={DetailIcon} alt="icon-detail" onClick={() => toUserDetail(item.id)} />
                        </button>
                    </Tooltip>
                </div>
            )
        }
    ));

    function deleteData(id, updated_at, user_name) {
        setSelectedUserId(id)
        setSelectedUpdatedAt(updated_at)
        setSelectedUserName(user_name)
        // doDeleteVehicle(id, updated_at)
        setDeleteConfirmationModalOpen(true)
    }

    return (
        <div className='p-[24px] flex flex-col gap-[24px]'>

            <ModalFailedDelete 
                show={cannotDeleteError}
                action={() => setCannotDeleteError(false)}
                closable={false}
                width={414}
                className={style.deleteModal}
                okText="Ok"
                title="Data cannot be deleted"
            />

            <DeleteConfirmationModal
                isOpen={deleteConfirmationModalOpen}
                onOk={() => setDeleteConfirmationModalOpen(false)}
                onCancel={() => doDeleteUser(selectedUserId, selectedUpdatedAt)}
                closable={false}
                width={440}
                className={style.modalContainer}
                okText="Cancel"
                cancelText="Yes, Delete"
                title="Delete Data?"
                description={<p>Are you sure want to delete <br /> <strong>{selectedUserId} - {selectedUserName}</strong></p>}
            />

            <SuccessModal
                isOpen={successModalOpen}
                onOk={() => doGetListUser(1, 10, 'id asc')}
                closable={false}
                width={280}
                className={style.deleteModal}
                okText="Ok"
                title="Well Done"
                description="Your data has been deleted"
            />

            <Breadcumbs
                jmlLevel={3}
                menuLevel1={`Admin`}
                menuLevel2={`User Management`}
                menuLevel3={`User`}
            />

            <h1 className='font-sans-bold text-2xl' id='title'>{t("USER:TITLE")}</h1>

            <div className={style.headerContainer + ' flex justify-between items-center'}>
                <AutoComplete
                    options={options}
                    onSelect={onSelect}
                    allowClear={true}
                    onClear={() => onClear()}
                    onChange={(value) => onSearch(value)}
                // suffix={<img src={SearchIcon} />}
                >
                    <Input
                        placeholder={t("USER:SEARCH_PLACEHOLDER")}
                        height={47}
                        suffix={() => !searchKeyword ? <img src={SearchIcon} alt="icon-search" /> : ''}
                        style={{ fontSize: "20px", zIndex: "0" }}
                    />
                </AutoComplete>

                <PrimaryButton text={t("USER:INVITATION")} suffixIcon={<img src={MailIcon} alt="icon-mail" />} action={toInviteList} />

            </div>

            <div className={style.tableContainer}>

                <CustomTable currentPage={currentPage} columns={UserListColumn} onChange={(page, pageSize) => handleChangeLimit(page, pageSize)} pageLimit={statePageSize} total={totalData} data={dataSource} showPagination />

            </div>

        </div>
    );
}